import Image from "next/image";
import type { StaticImageData } from "next/image";

import { Noise } from "@ui/components/core/Noise/Noise";

interface CalculatorResultCardShellProps {
  coverImage?: StaticImageData;
  bg: "black" | "cream";
  children: React.ReactNode;
}

const BG_CLASS = {
  black: "tw-bg-black",
  cream: "tw-bg-cream",
} as const;

/**
 * Shared shell for calculator result cards (API PAYG, API subscription, agents tier).
 * Renders a square card with a background colour, optional cover image, noise texture
 * and a padded content slot for the body.
 */
export function CalculatorResultCardShell({ coverImage, bg, children }: CalculatorResultCardShellProps) {
  return (
    <div className='tw-relative lg:tw-aspect-square tw-w-full'>
      <div className='tw-relative lg:tw-absolute tw-inset-0 tw-overflow-hidden tw-rounded-2xl'>
        <div className={`tw-absolute tw-inset-0 tw-w-full tw-h-full ${BG_CLASS[bg]}`} />
        {coverImage && (
          <div className='tw-absolute tw-inset-0 tw-w-full tw-h-full'>
            <Image src={coverImage} alt='' fill className='tw-object-cover' quality={90} placeholder='blur' />
          </div>
        )}
        <Noise className='tw-rounded-2xl' />
        <div className='tw-relative tw-p-5 lg:tw-p-10 tw-flex tw-flex-col tw-h-full tw-z-10'>{children}</div>
      </div>
    </div>
  );
}
